import { render, staticRenderFns } from "./editPwd.vue?vue&type=template&id=879071b0&scoped=true"
import script from "./editPwd.vue?vue&type=script&lang=js"
export * from "./editPwd.vue?vue&type=script&lang=js"
import style0 from "./editPwd.vue?vue&type=style&index=0&id=879071b0&prod&lang=stylus&scoped=true"
import style1 from "./editPwd.vue?vue&type=style&index=1&id=879071b0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879071b0",
  null
  
)

export default component.exports